import { createV3Queries } from "@query/utils/createV3Queries";
import { payoutsApi } from "@api";

export const queriesPayouts = createV3Queries("payoutsApi", payoutsApi, {
  upsertPayeePayoutSettings: queries => ({
    dependencies: () => [
      queries.getPayoutSettings.queryKeyBase,
      queries.listPayoutSettings.queryKeyBase
    ]
  })
});
